import { Modal, Button, Text, Group } from '@mantine/core';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { AppState } from '../../client-redux/reducers';
import { Language } from '../../languages/languageHandler';
import CustomModal from '../custom-modal';
import * as Icon from '@tabler/icons-react';
import './styles.scss';

interface ConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  text: string;
  successText: string;
  errorText: string;
}

const ConfirmationModal = ({ opened, onClose, onConfirm, text, successText, errorText }: ConfirmationModalProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);

  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);

  const handleConfirm = async () => {
    onClose();
    try {
      await onConfirm();
      setShowSuccessDialog(true);

      setTimeout(() => setShowSuccessDialog(false), 2000);
    } catch (err) {
      setShowErrorDialog(true);

      setTimeout(() => setShowErrorDialog(false), 3000);
    }
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={onClose}
        withCloseButton={false}
        centered
        radius="md"
        padding="lg"
        className="confirmation-modal"
        zIndex={11000}
      >
        <Text>{text}</Text>
        <Group style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1rem' }}>
          <Button
            radius="md"
            onClick={handleConfirm}
            leftSection={<Icon.IconCheck stroke={2} />}
            className="yes-button"
          >
            {lang.YES}
          </Button>
          <Button radius="md" onClick={onClose} leftSection={<Icon.IconX stroke={2} />} className="no-button">
            {lang.NO}
          </Button>
        </Group>
      </Modal>

      <CustomModal
        opened={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        message={successText}
        backgroundColor="#3BDF70"
        textColor="black"
      />

      <CustomModal
        opened={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        message={errorText}
        backgroundColor="#E3353F"
        textColor="white"
      />
    </>
  );
};

export default ConfirmationModal;
